<div class="ddc-logo-main-container" matTooltip="Daydic">
  <div class="ddc-logo-container" *ngIf="!_hasText">
    <img
      class="ddc-logo-img"
      [ngClass]="{
        'logo-img-dark-theme': _isDarkTheme,
        'logo-img-light-theme': _isLightTheme,
        'logo-img-paper-theme': _isPaperTheme,
      }"
      [src]="'assets/media/logos/logo.png'"
    />
  </div>
  <div
    class="ddc-logo-text-container"
    *ngIf="_hasText"
    [ngClass]="{
      'ddc-logo-text-container': _size === 'small',
      'ddc-logo-text-container-medium': _size === 'medium',
    }"
  >
    <img
      class="ddc-logo-text"
      [ngClass]="{
        'logo-img-dark-theme': _isDarkTheme,
        'logo-img-light-theme': _isLightTheme,
        'logo-img-paper-theme': _isPaperTheme,
      }"
      [src]="'assets/media/logos/logo_text.png'"
    />
  </div>
</div>
